<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
    >
      <a-form-model-item label="登录密码" prop="provinceCode">
        <a-select
          v-model="formData.provinceCode"
          placeholder="请选择省份"
          allow-clear
        >
          <a-select-option
            v-for="item in provinceList"
            :value="item.code"
            :key="item.code"
            >{{ item.descript }}({{ item.code }})</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="城市名称" prop="descript"
        ><a-input v-model="formData.descript" :maxLength="20"
      /></a-form-model-item>
      <a-form-model-item label="城市代码" prop="code"
        ><a-input
          v-model="formData.code"
          :maxLength="20"
          :disabled="modal.type == 'add' ? false : true"
      /></a-form-model-item>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否首都"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isCapital == 'T' ? true : false"
              @change="onChange('isCapital')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="是否热门城市"
            :label-col="{ span: 10 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isCityHot == 'T' ? true : false"
              @change="onChange('isCityHot')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否省会"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isProvinceCapital == 'T' ? true : false"
              @change="onChange('isProvinceCapital')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="是否开通运营"
            :label-col="{ span: 10 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isOpen == 'T' ? true : false"
              @change="onChange('isOpen')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-form-model-item label="帮助代码" prop="helpCode"
        ><a-input v-model="formData.helpCode" :maxLength="20"
      /></a-form-model-item>
      <a-form-model-item label="邮政编码" prop="zipcode"
        ><a-input v-model="formData.zipcode" :maxLength="10"
      /></a-form-model-item>
      <a-form-model-item label="电话区号" prop="phoneCode"
        ><a-input v-model="formData.phoneCode" :maxLength="10"
      /></a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "CityInfo",
  props: {
    provinceList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        countryCode: "China",
        provinceCode: "",
        descript: "",
        code: "",
        isCapital: "F",
        isCityHot: "F",
        isProvinceCapital: "F",
        isHalt: "F",
        isOpen: "F",
        helpCode: "",
        zipcode: "",
        phoneCode: ""
      },
      //form rules
      rules: {
        provinceCode: [
          {
            required: true,
            message: "请输选择省份",
            trigger: "change"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入城市代码",
            trigger: "change"
          }
        ],
        descript: [
          {
            required: true,
            message: "请输入城市名称",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    show(item) {
      this.modal = item;
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.$refs.ruleForm.resetFields();
      this.formData = {
        countryCode: "China",
        provinceCode: "",
        descript: "",
        code: "",
        isCapital: "F",
        isCityHot: "F",
        isProvinceCapital: "F",
        isOpen: "F",
        isHalt: "F",
        helpCode: "",
        zipcode: "",
        phoneCode: ""
      };
      this.confirmLoading = false;
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true;
          let param = Object.assign({}, this.formData);
          this.$http.systemBksApi
            .modifyCodeCity(param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>
